<template>
  <div class="main-view rewards-container">
		<!-- HEADER STARTS HERE  -->
		<div class="bg-container rewards-hero" :style="{'background-image': 'url(' + require(`../assets/img/bgs/hero-bg-02.svg`) + ')'}">
			<!-- <h1>Meaningful rewards, <br> experiences and{{'\xa0'}}savings.</h1>
			<p>Evergrow helps you recognize and motivate great work with the largest<br> collection of the world’s most loved rewards, experiences and{{'\xa0'}}savings.</p>
			<button>Book a demo</button> -->
			<div class="template-inner">
				<h1 class="hero-header">Meaningful rewards, <br> experiences and{{'\xa0'}}savings.</h1>
				<p class="hero-body">Evergrow helps you recognize and motivate great work with the largest<br> collection of the world’s most loved rewards, experiences and{{'\xa0'}}savings.</p>
				<button @click="$router.push('/book-a-demo')">book a demo</button>
			</div>
		</div>
		<!-- HEADER ENDS HERE -->
		<!-- REWARD POINTS STARTS HERE -->
		<section class="rewards-points-container template-inner flex-row">
			<div class="rewards-points-inner one-quarter">
				<div class="rewards-points-icon icon-1">
					<img src="@/assets/img/icons/rewards/star.svg" alt="">
				</div>
				<p class="points">10m+</p>
				<p class="orange point-desc">Rewards 
				<br>Worldwide</p>
			</div>
			<div class="rewards-points-inner one-quarter">
				<div class="rewards-points-icon icon-2">
					<img src="@/assets/img/icons/rewards/shopping-bag2.png" alt="">
				</div>
				<p class="points">2,500</p>
				<p class="eg-blue point-desc">Merchandise 
				<br>Brands</p>
			</div>
			<div class="rewards-points-inner one-quarter">
				<div class="rewards-points-icon icon-3">
					<img src="@/assets/img/icons/rewards/gift.svg" alt="">
				</div>
				<p class="points">2,500+</p>
				<p class="eg-pink point-desc">Gift Card 
				<br>Brands</p>
			</div>
			<div class="rewards-points-inner one-quarter">
				<div class="rewards-points-icon icon-4">
					<img src="@/assets/img/icons/rewards/airplane4.png" alt="">
				</div>
				<p class="points">1m+</p>
				<p class="eg-purple point-desc">Hotel, Travel 
				<br>& Expereinces</p>
			</div>
		</section>
		<!-- REWARD POINTS ENDS HERE -->
		<!-- PERSONALIZED REWARDS STARTS HERE -->
		<section class="personalized-rewards template-inner flex-row">
			<div class="left-half one-half">
				<img src="@/assets/img/icons/recognition/money.svg" alt="">
				<h2>AI-personalized rewards</h2>
				<p>Your members can redeem from an AI-personalized catalog that features over 2,500 merchandise brands like Apple, Cabela’s and Fitbit, 2,500 gift cards, 850 mobile top-up carriers, nearly 2 million charities, and much more. Evergrow can also reward your employees with a world of exclusive experiences. Our reward catalog features over a million hotel, resort, flight, cruise and exotic car rental discounts. Plus, members can redeem for over 17,000 events, concerts and guided tours, with insider access to tickets for the NFL, Broadway theatre and more. And because everyone is unique, our Evergrow AI engine personalizes and suggests the perfect reward to match a member’s unique interests.</p>
			</div>
			<div class="right-half one-half">
				<img class="img-4" src="@/assets/img/home/reward-bubble-2.png" alt="Apple logo">
				<img class="img-5" src="@/assets/img/home/reward-bubble-3.png" alt="Cabela's logo">
				<img class="img-6" src="@/assets/img/home/rewards-bubble-8.svg" alt="NFL Logo">
				<img class="img-7" src="@/assets/img/home/reward-bubble-6.png" alt="Fit bit logo">
				<div class="img-8-container">
					<img class="img-8" src="@/assets/img/icons/rewards/suitcase.svg" alt="suitcase">
				</div>
			</div>
		</section>
		<!-- PERSONALIZED REWARDS ENDS HERE -->
		<!-- PERSONALIZED SAVINGS STARTS HERE -->
		<section class="personalized-savings template-inner flex-row">
			<div class="left-half one-half">
				<img class="img-12" src="@/assets/img/home/savings-bubble-4.png" alt="GAP logo">
				<img class="img-13" src="@/assets/img/home/savings-bubble-6.png" alt="Bass Pro Shop logo">
				<img class="img-14" src="@/assets/img/home/savings-bubble-2.png" alt="AT&T logo">
			</div>
			<div class="right-half one-half">
				<img src="@/assets/img/icons/rewards/piggy-bank.svg" alt="">
				<h2>AI-personalized savings</h2>
				<p>Everybody likes to save, and Evergrow has created the world’s biggest savings hub. Hundreds of thousands of discounts are available on movie tickets, gift cards, travel, events, fashion, electronics and more from brands that people love the most, like Apple, Sony, BOSS, FitBit, Fossil, Garmin and more. How much could you save? Our AI scours the largest online stores daily to price compare and save members up to 65% off fashion, 50% off watches, and 25% off electronics. With discounts that average $20 per offer, a large company could deliver over $4.4 million in savings every year to their members.</p>
			</div>
		</section>
		<!-- PERSONALIZED SAVINGS ENDS HERE -->
		<!-- ADDITIONAL BENEFITYS STARTS HERE -->
		<section class="additional-benefits-container">
			<div class="template-inner">
				<h2>Additional Benefits</h2>
				<div class=" flex-row align-start">
					<div class="benefits-left one-half">
						<img src="@/assets/img/icons/rewards/map.svg" alt="">
						<h3>Evergrow hyperlocal daily deals</h3>
						<p>With a minimum purchase of $250, members receive one year of free Community Savings – deals and discounts at local restaurants, coffee shops and retail stores. These instant daily deals are personalized for you and geo-located for your neighbourhood. Plus, you never need to use any points to enjoy the savings. You can even share Evergrow Savings with your family, so everyone can save, every day.</p>
					</div>
						<div class="benefits-right one-half">
						<img src="@/assets/img/icons/rewards/reward.svg" alt="">
						<h3>Simplified reward financing</h3>
						<p>We’ve made it easier for Evergrow members to get the rewards they want without the wait. Evergrow financing offers low-to-no interest microloans and payroll deduction flexibility so members can buy rewards, even if they don’t have enough points.</p>
					</div>
				</div>
			</div>
		</section>
		<!-- ADDITIONAL BENEFITYS ENDS HERE -->
		<section class="rewards-info-container rewards">
				<div class="stroke"></div>
				<div class='rewards-info-inner rewards'>
					<img class="rewards-star-icon" src="@/assets/img/icons/rewards/yellow-star.svg" alt="star icon">
					<p>There are many ways a member can be recognized and earn points.</p>
					<!-- <button class="rewards-button">Learn more</button> -->
					<button class="rewards-button" @click="$router.push('/features/recognition')">Learn{{'\xa0'}}more</button>
				</div>
				<div class="stroke"></div>
		</section>
		<Demo></Demo>
  </div>
</template>

<script>
import Demo from "../components/Demo";
	export default {
		name: 'Features-Rewards',
		components : {
			Demo
		}
	}
</script>

<style lang="stylus">

// ----- HEADER -----


	.bg-container.rewards-hero
			
		text-align center
		background center bottom / cover no-repeat
		display flex
		flex-direction column
		justify-content center
		align-items center
		padding 270px 0 240px

	.rewards-hero
		text-align center
		
		p.hero-body
			margin-bottom 20px 
			
		button 
			// margin-top 30px

	h1
		font-size 70px
		margin-bottom 25px


	// ----- REWARD POINTS BOXES -----

	.rewards-points-container 
		width 75%
		margin 0 auto
		flex-wrap wrap
		margin-top -108px
		.rewards-points-inner 
			background white
			box-shadow: 0px 40px 80px #00000033;
			text-align  center
			border-radius 40px
			margin-bottom 20px
			padding 0 20px 20px


	.points
		font-size 56px
		text-transform uppercase
		font-weight 400
		line-height 1.7

	.rewards-points-icon 
		display inline-block
		padding 18px
		border-radius 50%
		margin-top -37px
		margin-bottom 25px
		box-shadow 0px 20px 40px #00000029
		img	
			width 50px

	.icon-1
		background #FF8D03
		padding 16px 18px 13px 18px
	.icon-2
		background #00AEFF
		padding 11px 16px 9px 16px
	.icon-3
		background #FF31AF
	.icon-4
		background #AA34BC
		padding 14px 15px 14px 17px 
		img
			width 55px
			

	.point-desc
		font-size 20px
		font-weight 400
		line-height 30px
		// padding-bottom 16px

	//----- PERSONALIZED REWARDS -----

	.personalized-rewards, .personalized-savings
		// width 90%
		margin 150px auto 0

	.personalized-rewards .left-half
		margin 0
		height 550px
		p
			width 93%

	h2 
		font-size 50px
		width 96%
	
	.personalized-rewards 
		position relative
		
		.right-half 
			background url('~@/assets/img/features/rewards-tiles.png') center center / contain no-repeat transparent
			align-self stretch
			position relative

	.personalized-rewards .right-half img 	
		position absolute
		box-shadow 0 20px 40px #00000029
		border-radius 100%

	.img-4
		z-index 2
		width 150px
		top 5%
		left 4%

	.img-5
		z-index 2
		width 110px
		left 7%
		bottom 21%

	.img-6 
		width 90px
		bottom 3%
		right 26%

	.img-7
		width  150px
		right 12%
		top 42%
	
	.personalized-rewards .right-half .img-8-container
		position absolute
		z-index 1
		width 90px
		height 90px
		background #fff
		box-shadow 0 20px 40px #00000029
		border-radius 100%
		display flex
		justify-content center
		align-items center
		right 44%
		top -3%
		
		.img-8
			width 38px
			border-radius 0


	//----- PERSONALIZED SAVINGS -----
	.personalized-savings
		margin-top 140px
		position relative
		margin-bottom 90px
		
		.left-half 
			background url('~@/assets/img/features/savings-tiles.png') center center / contain no-repeat transparent
			align-self stretch
			position relative
			
		.left-half img
			position absolute
			border-radius 100%
			box-shadow 0 20px 40px #00000029
			
			
		.right-half
			margin 0
			height 550px
			padding-top 60px

		.right-half h2 
			width 93%

	.img-12
		width 140px
		top -6%
		left 43%

	.img-13
		width 100px
		top 11%
		right 10%

	.img-14
		width 140px
		left 16%
		top 44%

	// ----- ADDITIONAL BENEFITS -----

	h3
		font-size 20px
		margin-bottom 20px

	.additional-benefits-container
		background url('~@/assets/img/bgs/wave-bg.svg') center center / cover no-repeat
		padding-top 220px
		padding-bottom 150px
		margin-bottom -120px
		h2
			text-align center
			margin-bottom 40px

	.additional-benefits-inner	
		width 75%
		margin 0 auto

	.benefits-left img, 
	.benefits-right img 
		width 50px
		margin-bottom 7px

	.benefits-left p
		width  80%

	.rewards-info-container.rewards
		background #f7f7f7
		margin 80px auto 0
		padding-bottom 250px

	// ----- DEMO -----
	.rewards-container .demo-container 
		margin-top -120px
		
	@media (max-width: 1000px)
	
		.rewards-hero h1 
			font-size 52px
			width 100%
			margin 0 auto 30px
			text-align center
			
		.rewards-hero p
			width 100%
			margin 0 auto
			
			br 
				display none
				
		.rewards-points-container.template-inner.flex-row
			flex-direction column
			
			.one-quarter
				width 100% !important
				margin-bottom 100px
				
		.rewards-points-icon
			width 110px
			height 110px
			
			img 
				position relative
				top 50%
				margin-top -28px
				
		.rewards-points-inner.one-quarter p:not(.points)
			font-size 18px
			margin-bottom 10px
			
		.personalized-rewards,
		.personalized-savings
			margin 20px auto 0
		
		.personalized-rewards.template-inner.flex-row
			flex-direction column-reverse
			
			.one-half
				width 100% !important
				
			.left-half
				height auto
				
			.right-half
				height 440px
				background-size	90%
				background-position-x right
				margin-bottom 0
				
				.img-4
					width 75px
					top: 21%;
					left: 7%;
					
				.img-5
					width 54px
					left: 14%;
					bottom: 28%;
				
				.img-6
					width 60px
					right: 16%;
					bottom: 10%;
					
				.img-7
					width 80px
					right: 6%;
					bottom: 28%;
					
				.img-8-container
					width 60px 
					height 60px
					top 7%
					
					img
						width 26px
		
		.personalized-savings.template-inner.flex-row
			flex-direction column
			
			.one-half
				width 100% !important
				
			.left-half 
				height 440px
				margin-top 80px
				
				.img-12
					width 80px
					top 6%
					
				.img-13
					width 60px
					top 18%
					right 6%
				
				.img-14
					width 80px
				
			.right-half
				height auto
				padding-top 0
				
		.additional-benefits-container 
			background-image none
			background-color #F7F7F7
			padding-top 60px
			margin-top 80px
			h2
				font-size 40px
			.flex-row
				flex-direction column 

				.one-half
					width 100% !important
					margin-bottom 60px
					
				.benefits-left p
					width 100%
		
		.rewards-info-container.rewards
			margin-top 10px
			
			.stroke
				display none
</style>